(function () {
  'use strict';
  var script = document.currentScript;
  var stylesheet = script && script.getAttribute('data-stylesheet');
  if (!stylesheet || !window.customElements) return;
  var hosts = new WeakSet();

  function enhance(host) {
    var root = host.shadowRoot;
    if (!root || hosts.has(host)) return;
    hosts.add(host);
    host.setAttribute('data-fs-editorial-slider', '20260924');
    var track = null;
    var frame = 0;
    var container = document.querySelector('product-component[data-modal="false"] .page-width') || document.querySelector('.product-section .page-width');
    var resize = window.ResizeObserver ? new ResizeObserver(schedule) : null;

    function schedule() {
      if (!frame) frame = requestAnimationFrame(sync);
    }
    function sync() {
      frame = 0;
      if (!host.isConnected) { if (resize) resize.disconnect(); observer.disconnect(); return; }
      if (container) {
        var box = container.getBoundingClientRect();
        var style = getComputedStyle(container);
        var width = box.width - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        if (width > 0) host.style.setProperty('--fs-recommendation-width', width + 'px');
      }
      if (!root.querySelector('[data-fs-editorial-styles]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet'; link.href = stylesheet; link.setAttribute('data-fs-editorial-styles', '');
        link.addEventListener('load', schedule, { once: true });
        root.appendChild(link);
      }
      var current = root.querySelector('.ais-recommendation-list');
      if (current !== track) {
        if (track) { track.removeEventListener('scroll', schedule); if (resize) resize.unobserve(track); }
        track = current;
        if (track) { track.addEventListener('scroll', schedule, { passive: true }); if (resize) resize.observe(track); }
      }
      var controls = root.querySelector('.ais-carousel-controls');
      var previous = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      var progress = root.querySelector('.fs-recommendation-progress');
      if (!progress && track) {
        progress = document.createElement('div'); progress.className = 'fs-recommendation-progress';
        progress.setAttribute('aria-hidden', 'true'); progress.appendChild(document.createElement('span'));
        track.parentNode.appendChild(progress);
      }
      var max = track ? Math.max(0, track.scrollWidth - track.clientWidth) : 0;
      var position = track ? Math.max(0, track.scrollLeft) : 0;
      if (controls) controls.hidden = max < 2;
      if (previous) previous.disabled = position <= 2;
      if (next) next.disabled = position >= max - 2;
      if (progress) {
        progress.hidden = max < 2;
        if (track && max >= 2) {
          var fraction = track.clientWidth / track.scrollWidth;
          progress.firstElementChild.style.width = (fraction * 100) + '%';
          progress.firstElementChild.style.transform = 'translateX(' + (position / max * (1 - fraction) / fraction * 100) + '%)';
        }
      }
    }
    var observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true });
    if (resize) { resize.observe(host); if (container) resize.observe(container); }
    window.addEventListener('resize', schedule, { passive: true });
    schedule();
  }
  function scan() { document.querySelectorAll('ai-search-product-discovery').forEach(enhance); }
  customElements.whenDefined('ai-search-product-discovery').then(function () {
    scan();
    var main = document.querySelector('#MainContent');
    if (main) new MutationObserver(function (records) {
      if (records.some(function (r) { return Array.from(r.addedNodes).some(function (n) {
        return n.nodeType === 1 && (n.matches('ai-search-product-discovery') || n.querySelector('ai-search-product-discovery'));
      }); })) scan();
    }).observe(main, { childList: true, subtree: true });
  });
  document.addEventListener('shopify:section:load', scan);
}());
